import { Wrench } from 'lucide-react';

import { useBreadcrumbs } from '@/client/hooks/use-breadcrumbs';
import { BrainShell } from './BrainSegments';

type ActivityRow = {
  id: string;
  when: string;
  actor: string;
  summary: string;
  kind: 'Chat' | 'Tool' | 'Index';
  detail: string;
};

const MOCK_ACTIVITY: ActivityRow[] = [
  {
    id: 'a1',
    when: 'Just now',
    actor: 'you',
    summary: 'How many CMS drafts are waiting?',
    kind: 'Chat',
    detail: '12 drafts · linked /admin/content/pages',
  },
  {
    id: 'a2',
    when: '4m ago',
    actor: 'Brain',
    summary: 'list_cms_pages',
    kind: 'Tool',
    detail: 'status=draft · limit=20',
  },
  {
    id: 'a3',
    when: '22m ago',
    actor: 'you',
    summary: 'Show payment failures today',
    kind: 'Chat',
    detail: '7 failed charges · mock ledger',
  },
  {
    id: 'a4',
    when: '1h ago',
    actor: 'Brain',
    summary: 'query_payments',
    kind: 'Tool',
    detail: 'outcome=failed · window=24h',
  },
  {
    id: 'a5',
    when: '3h ago',
    actor: 'system',
    summary: 'Re-indexed CMS publishing playbook',
    kind: 'Index',
    detail: '48 chunks · knowledge base',
  },
  {
    id: 'a6',
    when: 'Yesterday',
    actor: 'you',
    summary: 'Who joined in the last 7 days?',
    kind: 'Chat',
    detail: '41 new users · mock cohort',
  },
];

const kindClass: Record<ActivityRow['kind'], string> = {
  Chat: 'bg-blue-50 text-blue-800 border-blue-100',
  Tool: 'bg-amber-50 text-amber-900 border-amber-100',
  Index: 'bg-slate-50 text-slate-800 border-slate-200',
};

const BrainActivityPage = () => {
  useBreadcrumbs([
    { label: 'Brain', href: '/admin/ai' },
    { label: 'Activity' },
  ]);

  return (
    <BrainShell
      title="Activity"
      description="Mock trail of chats, tool calls, and knowledge indexing."
    >
      <ol className="space-y-3">
        {MOCK_ACTIVITY.map((row) => (
          <li
            key={row.id}
            className="flex gap-3 rounded-xl border border-gray-200 bg-white px-4 py-3 shadow-sm"
          >
            <div className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-gray-50 text-gray-600">
              <Wrench className="h-4 w-4" />
            </div>
            <div className="min-w-0 flex-1">
              <div className="flex flex-wrap items-center gap-2">
                <span
                  className={`inline-flex rounded-md border px-2 py-0.5 text-[11px] font-medium ${kindClass[row.kind]}`}
                >
                  {row.kind}
                </span>
                <span className="text-xs text-gray-400">{row.when}</span>
                <span className="text-xs text-gray-400">· {row.actor}</span>
              </div>
              <p className="mt-1 truncate text-sm font-medium text-gray-900">{row.summary}</p>
              <p className="text-xs text-gray-500">{row.detail}</p>
            </div>
          </li>
        ))}
      </ol>
    </BrainShell>
  );
};

export default BrainActivityPage;
